import React from 'react';

import RelatedImg from './RelatedImg';

const Related = (props) => {
    const getRelated = (related) => {
        return related.map((article) => {
            return (
                <div key={article.ID} className="col-6 related-article">
                    <RelatedImg article={article} />
                </div>
            );
        });
    };

    return <div id="related">{getRelated(props.related)}</div>;
};

export default Related;



// WEBPACK FOOTER //
// ./src/components/Pages/Related.jsx